/* global debounce */

if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.results = this.querySelector('.js-search-results');
      this.overlay = this.querySelector('.js-search-overlay');
      this.statusEl = this.querySelector('.js-search-status');
      this.loadingText = this.getAttribute('data-loading-text');
      this.addListeners();
    }

    /**
     * Triggers when the web component is removed from the DOM
     */
    disconnectedCallback() {
      this.close();
    }

    addListeners() {
      this.input.addEventListener('focus', this.handleFocus.bind(this));
      this.input.addEventListener('input', debounce(this.handleInput.bind(this)));
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.handleProductTypeChange.bind(this));
      }
      this.querySelector('.search').addEventListener('submit', this.handleSubmit.bind(this));
    }

    /**
     * Gets the value of the search input field.
     * @returns {string}
     */
    getQuery() {
      return this.input.value.trim();
    }

    /**
     * Handles search form submit.
     * @param {object} evt - Event object.
     */
    // handleSubmit(evt) {
    //   if (
    //     !this.getQuery().length
    //     || this.querySelector('.predictive-search__item[aria-selected="true"]:not(.js-submit)')
    //   ) {
    //     evt.preventDefault();
    //   }
    // }
    handleSubmit(evt) {
      const query = this.getQuery();
      const hasSelectedItem = this.querySelector(
        '.predictive-search__item[aria-selected="true"]:not(.js-submit)'
      );

      if (!query.length || hasSelectedItem) {
        evt.preventDefault();
        return;
      }

      const activeBrand = this.getActiveBrand();
      if (activeBrand) {
        evt.preventDefault();
        const encodedBrand = encodeURIComponent(activeBrand.toLowerCase());
        const encodedQuery = encodeURIComponent(query);
        // Full search page also filtered by tag
        // window.location.href = '/search?type=product&q=tag:' + encodedBrand + ' AND ' + encodedQuery;
        window.location.href = '/search?type=product&q=' + encodedQuery + ' AND tag:' + encodedBrand;
      }
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      // autocomplete=off prevents browser from restoring value after using back button in Safari
      this.input.setAttribute('value', this.input.value);

      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        this.close();
        return;
      }

      this.getResults(searchTerm);
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
      const query = this.getQuery();
      if (query.length > 0) {
        this.getResults(query);
      }
    }

    /**
     * Handles 'focus' events on the search field.
     */
    handleFocus() {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;

      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getResults(searchTerm);
      }
    }

    /**
     * Handles 'keydown' events on the custom element.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      // Let tabs script handle keydown events on the tab buttons.
      if (evt.target.matches('.tablist__tab')) return;

      switch (evt.key) {
        case 'ArrowUp':
        case 'ArrowDown':
          evt.preventDefault();

          if (this.hasAttribute('open')) {
            this.handleResultsNav(evt.key);
          }
          break;

        case 'Enter':
          this.selectOption();
          break;

        case 'Escape':
          this.close();
          break;

        // no default
      }
    }

    /**
     * Handles 'keyup' events on the custom element.
     */
    handleKeyup() {
      // If search field is empty after key press, close the results.
      if (!this.getQuery().length) this.close();
    }

    /**
     * Handles keyboard navigation of the results.
     * @param {string} key - Key pressed.
     */
    handleResultsNav(key) {
      const selectedResult = this.querySelector(
        '[role="tabpanel"]:not([hidden]) [aria-selected="true"]'
      );
      const allResults = this.querySelectorAll(
        '[role="tabpanel"]:not([hidden]) .predictive-search__item'
      );
      let resultToSelect = allResults[0];

      if (key === 'ArrowUp') {
        if (!selectedResult) return;

        // Select the next result up or the last one if we've reached the top of the list.
        resultToSelect = selectedResult.previousElementSibling || allResults[allResults.length - 1];
      } else if (key === 'ArrowDown') {
        if (selectedResult) {
          // Select the next result down or the first one if we've reached the bottom of the list.
          resultToSelect = selectedResult.nextElementSibling || allResults[0];
        }
      }

      this.statusEl.textContent = '';

      if (resultToSelect) {
        // If the selected item didn't change, do nothing.
        if (resultToSelect === selectedResult) return;

        resultToSelect.setAttribute('aria-selected', 'true');
        if (selectedResult) selectedResult.setAttribute('aria-selected', 'false');

        this.setLiveRegionText(resultToSelect.textContent);
        this.input.setAttribute('aria-activedescendant', resultToSelect.id);
      }
    }

    /**
     * Selects a result
     */
    selectOption() {
      const selectedResult = this.querySelector('[aria-selected="true"] > .js-search-link');
      if (selectedResult) selectedResult.click();
    }

    /**
     * Gets the results for a search term.
     * @param {string} searchTerm - Search query.
     */
    // async getResults(searchTerm) {
    //   this.setLiveRegionLoadingState();

    //   let searchFields = 'title,product_type,variants.title,vendor';
    //   if (theme.settings.pSearchIncludeSkus) searchFields += ',variants.sku';
    //   if (theme.settings.pSearchIncludeTags) searchFields += ',tag';

    //   let searchParams = '';
    //   if (this.productTypeInput && this.productTypeInput.value !== '') {
    //     searchParams = `q=product_type:${encodeURIComponent(this.productTypeInput.value)} AND ${encodeURIComponent(searchTerm)}`;
    //   } else {
    //     searchParams = `q=${encodeURIComponent(searchTerm)}`;
    //   }

    //   searchParams += `&${encodeURIComponent('resources[limit]')}=${theme.settings.pSearchLimit}`;
    //   searchParams += `&${encodeURIComponent('resources[limit_scope]')}=${
    //     theme.settings.pSearchLimitScope
    //   }`;
    //   searchParams += `&${encodeURIComponent('resources[options][fields]')}=${searchFields}`;
    //   searchParams += '&section_id=predictive-search';

    //   const queryKey = searchParams.replace(' ', '-').toLowerCase();
      
    //   if (this.cachedResults[queryKey]) {
    //     this.renderResults(this.cachedResults[queryKey]);
    //     return;
    //   }

    //   try {
    //     const response = await fetch(`${theme.routes.predictiveSearch}?${searchParams}`);
    //     if (!response.ok) throw new Error(response.status);

    //     const tmpl = document.createElement('template');
    //     tmpl.innerHTML = await response.text();

    //     const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search');
    //     const resultsMarkup = resultsEl.innerHTML.replace(/psearch/g, this.input.id);

    //     this.cachedResults[queryKey] = resultsMarkup;
    //     this.renderResults(resultsMarkup);
    //   } catch (error) {
    //     this.close();
    //     throw error;
    //   }
    // }
    /**
     * Detects the active brand based on current page URL.
     * @returns {string|null} - Brand name or null if on all-brands page.
     */
    getActiveBrand() {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('/pages/audi') || path.includes('/collections/audi')) {
        return 'AUDI';
      } else if (path.includes('/pages/mercedes') || path.includes('/collections/mercedes')) {
        return 'Mercedes'; // ✏️ must match exactly what's in the metafield value
      } else if (path === '/' || path.includes('/pages/bmw') || path.includes('/collections/bmw')) {
        //return 'BMW';
      }

      return null; // No filter — show all brands (e.g. /search, /collections/all)
    }

    /**
     * Gets the results for a search term.
     * @param {string} searchTerm - Search query.
     */
    async getResults(searchTerm) {
      this.setLiveRegionLoadingState();

      let searchFields = 'title,product_type,variants.title,vendor';
      if (theme.settings.pSearchIncludeSkus) searchFields += ',variants.sku';
      if (theme.settings.pSearchIncludeTags) searchFields += ',tag';

      const activeBrand = this.getActiveBrand();

      // ── Step 1: Fetch HTML section for rendering (no brand filter) ──
      let searchParams = 'q=' + encodeURIComponent(searchTerm);
      searchParams += '&' + encodeURIComponent('resources[limit]') + '=' + theme.settings.pSearchLimit;
      searchParams += '&' + encodeURIComponent('resources[limit_scope]') + '=' + theme.settings.pSearchLimitScope;
      searchParams += '&' + encodeURIComponent('resources[options][fields]') + '=' + searchFields;
      searchParams += '&section_id=predictive-search';

      const queryKey = (activeBrand || 'all') + '-' + searchParams.replace(' ', '-').toLowerCase();

      if (this.cachedResults[queryKey]) {
        this.renderResults(this.cachedResults[queryKey]);
        return;
      }

      try {
        // ── Step 2: Also fetch JSON to get tags per product ──────────
        const jsonParams = 'q=' + encodeURIComponent(searchTerm)
          + '&' + encodeURIComponent('resources[type]') + '=product'
          + '&' + encodeURIComponent('resources[limit]') + '=' + theme.settings.pSearchLimit
          + '&' + encodeURIComponent('resources[options][fields]') + '=' + searchFields;

        const [htmlResponse, jsonResponse] = await Promise.all([
          fetch(theme.routes.predictiveSearch + '?' + searchParams),
          activeBrand ? fetch('/search/suggest.json?' + jsonParams) : Promise.resolve(null)
        ]);

        if (!htmlResponse.ok) throw new Error(htmlResponse.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await htmlResponse.text();

        const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search');
        let resultsMarkup = resultsEl.innerHTML.replace(/psearch/g, this.input.id);

        // ── Step 3: Filter HTML results using JSON tag data ──────────
        if (activeBrand && jsonResponse && jsonResponse.ok) {
          const jsonData = await jsonResponse.json();
          const products = (jsonData.resources && jsonData.resources.results && jsonData.resources.results.products) || [];

          // Build a set of handles that match the brand tag
          const brandHandles = new Set();
          products.forEach(function(product) {
            // console.log('product:', product.handle, '| tags:', product.tags);
            const tags = (Array.isArray(product.tags) ? product.tags : []).map(t => t.trim().toUpperCase());
            const brand = activeBrand.toUpperCase();
            const isMatch = tags.some(tag => tag.startsWith(brand));
            if (isMatch) {
              brandHandles.add(product.handle);
            }
          });

          // Remove non-matching product items from HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = resultsMarkup;

          const productLinks = tempDiv.querySelectorAll('.predictive-search__item a[href*="/products/"]');
          productLinks.forEach(function(link) {
            const href = link.getAttribute('href') || '';
            const handleMatch = href.match(/\/products\/([^?#]+)/);
            const handle = handleMatch ? handleMatch[1] : '';
            const item = link.closest('.predictive-search__item');
            if (item && handle && !brandHandles.has(handle)) {
              item.remove();
            }
          });

          resultsMarkup = tempDiv.innerHTML;
        }
        // ─────────────────────────────────────────────────────────────

        // ── Remove empty tab panels to prevent Tabs.js error ─────────
        if (activeBrand) {
          const tempDiv2 = document.createElement('div');
          tempDiv2.innerHTML = resultsMarkup;

          const tabPanels = tempDiv2.querySelectorAll('[role="tabpanel"]');
          tabPanels.forEach(function(panel) {
            const items = panel.querySelectorAll('.predictive-search__item');
            if (items.length === 0) {
              // Also remove the matching tab button
              const panelId = panel.id;
              if (panelId) {
                const tabBtn = tempDiv2.querySelector('[aria-controls="' + panelId + '"]');
                if (tabBtn) {
                  const tabLi = tabBtn.closest('li') || tabBtn;
                  tabLi.remove();
                }
              }
              panel.remove();
            }
          });

          // Activate first remaining tab button
          const firstTab = tempDiv2.querySelector('[role="tab"]');
          const firstPanel = tempDiv2.querySelector('[role="tabpanel"]');
          if (firstTab) firstTab.setAttribute('aria-selected', 'true');
          if (firstPanel) firstPanel.removeAttribute('hidden');

          resultsMarkup = tempDiv2.innerHTML;
        }
        // ─────────────────────────────────────────────────────────────

        // ── If filtering removed all products, show empty state ──────
        if (activeBrand) {
          const tempCheck = document.createElement('div');
          tempCheck.innerHTML = resultsMarkup;
          const remainingItems = tempCheck.querySelectorAll('.predictive-search__item');
          if (remainingItems.length === 0) {
            this.close();
            return;
          }
        }
        // ─────────────────────────────────────────────────────────────

        this.cachedResults[queryKey] = resultsMarkup;
        this.renderResults(resultsMarkup);
      } catch (error) {
        this.close();
        throw error;
      }
    }

    /**
     * Sets the live region loading state.
     */
    setLiveRegionLoadingState() {
      this.setLiveRegionText(this.loadingText);
    }

    /**
     * Sets the live region text.
     * @param {string} statusText - Status text.
     */
    setLiveRegionText(statusText) {
      this.statusEl.setAttribute('aria-hidden', 'false');
      this.statusEl.textContent = statusText;

      setTimeout(() => {
        this.statusEl.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Renders the results markup.
     * @param {string} resultsMarkup - Results markup.
     */
    renderResults(resultsMarkup) {
      this.results.innerHTML = resultsMarkup;
      this.setAttribute('results', true);
      this.open();
    }

    /**
     * Opens the results listbox.
     */
    open() {
      this.overlay.classList.add('is-visible');
      if (this.getQuery().length) this.resetBtn.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.setAttribute('open', '');
      document.body.classList.add('overlay-predictive-search');

      // Add event handlers (so the bound event listeners can be removed).
      this.keydownHandler = this.keydownHandler || this.handleKeydown.bind(this);
      this.keyupHandler = this.keyupHandler || this.handleKeyup.bind(this);
      this.resetBtnClickHandler = this.resetBtnClickHandler || this.close.bind(this);
      this.overlayClickHandler = this.overlayClickHandler || this.close.bind(this);

      // Add event listeners (for while results are open).
      this.addEventListener('keydown', this.keydownHandler);
      this.addEventListener('keyup', this.keyupHandler);
      this.resetBtn.addEventListener('click', this.resetBtnClickHandler);
      this.overlay.addEventListener('click', this.overlayClickHandler);
    }

    /**
     * Closes the results listbox.
     * @param {object} evt - Event object.
     */
    close(evt) {
      // If reset button was clicked, empty the input field.
      if (evt && evt.target === this.resetBtn) {
        this.input.value = '';
        this.removeAttribute('results');
        this.input.focus();
      }

      // Deselect the selected result (if there is one).
      const selected = this.querySelector('.predictive-search__item[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', 'false');

      this.removeAttribute('open');
      this.resetBtn.hidden = true;
      this.overlay.classList.remove('is-visible');
      this.input.setAttribute('aria-activedescendant', '');
      this.input.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overlay-predictive-search');

      // Remove event listeners added on search results opening.
      this.removeEventListener('keydown', this.keydownHandler);
      this.resetBtn.removeEventListener('click', this.resetBtnClickHandler);
      this.overlay.removeEventListener('click', this.overlayClickHandler);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
